(window.aeOnSectionReady || function (fn) { document.addEventListener('DOMContentLoaded', () => fn(document)); })((sectionRoot) => {
  document.querySelectorAll('.ae-lab-reports__card-media').forEach((media) => {
    if (media.dataset.aeMediaBound === 'true') return;
    media.dataset.aeMediaBound = 'true';
    media.addEventListener('contextmenu', (e) => e.preventDefault());
    media.addEventListener('dragstart', (e) => e.preventDefault());
    media.querySelectorAll('img').forEach((img) => {
      img.setAttribute('draggable', 'false');
    });
  });

  document.querySelectorAll('[data-ae-lr-slider]').forEach((slider) => {
    if (slider.dataset.aeBound === 'true') return;
    slider.dataset.aeBound = 'true';

    const viewport = slider.querySelector('[data-ae-lr-viewport]');
    const track = slider.querySelector('[data-ae-lr-track]');
    const slides = Array.from(track?.children || []);
    const prev = slider.querySelector('[data-ae-lr-prev]');
    const next = slider.querySelector('[data-ae-lr-next]');
    const progress = slider.querySelector('[data-ae-lr-progress]');
    if (!viewport || !track || slides.length === 0) return;

    function stepSize() {
      const card = slides[0];
      if (!card) return viewport.clientWidth;
      const cs = getComputedStyle(track);
      const gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      const max = viewport.scrollWidth - viewport.clientWidth;
      if (prev) prev.disabled = viewport.scrollLeft <= 1;
      if (next) next.disabled = viewport.scrollLeft >= max - 1;
      if (progress) {
        const ratio = max <= 0
          ? 1
          : Math.min(1, (viewport.scrollLeft + viewport.clientWidth) / viewport.scrollWidth);
        progress.style.width = `${Math.max(12, ratio * 100)}%`;
      }
    }

    prev?.addEventListener('click', () => {
      viewport.scrollBy({ left: -stepSize(), behavior: 'smooth' });
    });

    next?.addEventListener('click', () => {
      viewport.scrollBy({ left: stepSize(), behavior: 'smooth' });
    });

    viewport.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    update();
  });
});
